import { observer } from "mobx-react";
import { Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ILoginModal, IModal } from "../../stores/index.d";
import { useStores } from "../../stores/root-store";
import { useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { useAuth } from "../../contexts/auth-context";
import ForgotPasswordPage from "./forgot-password";
import RegisterPage from "./register";

const LoginPage = observer(
  ({ show, setShowModal, loginCallback }: ILoginModal) => {
    const { authStore } = useStores();
    const { login } = authStore;
    const navigate = useNavigate();
    const { setAuth } = useAuth();
    const [email, setEmail] = useState("");
    const [passWord, setPassword] = useState("");
    const [isFormValid, setIsFormValid] = useState(false);

    const [showPwdReset, setShowPwdReset] = useState(false);
    const [showRegister, setShowRegister] = useState(false);

    useEffect(() => {
      setIsFormValid(email && passWord ? true : false);
    }, [email, passWord]);

    const handleShowPwdReset = (show: boolean) => {
      setShowPwdReset(show);
      setShowModal(!show);
    };

    const handleShowRegister = (show: boolean) => {
      setShowRegister(show);
      setShowModal(!show);
    };

    const submitCallback = (res: boolean, token: string) => {
      if (res && token) {
        setAuth(token);
        setShowModal(false);
        if (loginCallback) {
          loginCallback();
        } else {
          navigate("/");
        }
      } else ShowAlert.Error("Invalid credentials");
    };

    const handleFormSubmit = () => {
      if (!isFormValid)
        ShowAlert.Error("Please make sure all the fields are entered.");
      else {
        login(email, passWord, submitCallback);
      }
    };

    return (
      <>
        <Modal
          show={show}
          onHide={() => setShowModal(false)}
          centered
          scrollable
          dialogClassName="modal-sm"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>Login</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="login-page">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <form autoComplete="off">
                        <div className="form-floating mb-3">
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <label htmlFor="email">Email address</label>
                        </div>
                        <div className="form-floating">
                          <input
                            type="password"
                            className="form-control"
                            id="pwd"
                            placeholder="Password"
                            value={passWord}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <label htmlFor="pwd">Password</label>
                        </div>
                        <div className="btn-group d-flex mt-3">
                          <button
                            className="btn btn-default rounded-0 flex-fill"
                            type="button"
                            onClick={handleFormSubmit}
                          >
                            Login
                          </button>
                        </div>
                        <div className="text-center mt-2">
                          <Link
                            to={"#"}
                            className="text-decoration-none"
                            onClick={() => setShowPwdReset(true)}
                          >
                            Forgot password
                          </Link>
                        </div>
                        <div className="text-center mt-2">
                          Don't have an account?{" "}
                        </div>
                        <div className="btn-group d-flex mt-3">
                          <button
                            className="btn btn-default rounded-0 flex-fill"
                            type="button"
                            onClick={() => setShowRegister(true)}
                          >
                            Register now
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {showPwdReset && (
              <ForgotPasswordPage
                show={showPwdReset}
                setShowModal={handleShowPwdReset}
              />
            )}
            {showRegister && (
              <RegisterPage
                show={showRegister}
                setShowModal={handleShowRegister}
              />
            )}
          </Modal.Body>
        </Modal>
      </>
    );
  }
);

export default LoginPage;
